<template>
  <div class="rc-box box-sizing">
      <div class="pt10 ml10">
      <div class=" title3 ">天天短网址充值</div>
      </div>
      <div class=" fs16 linehei2" style="width: 540px;padding:100px 0 0 100px;">

          <div class="flex-row">
              <div>用户ID：</div>
              <div  class="gray666">{{userInfo.uid}}</div>
          </div>
        <div class="flex-row mt10">
          <div>账户余额：</div>
          <div class="gray666">{{userInfo.money}} 元
          </div>
        </div>
        <div class="flex-row mt10">
          <div>充值金额：</div>
          <div class="flex-row">
            <el-input class="inp mr10" placeholder="请输入充值金额" v-model="money" ></el-input> 元
          </div>
        </div>
        <div class="flex-row mt10">
          <div>3.选择支付方式</div>
          <div>

          </div>
        </div>
        <div class="mt10">
        <el-radio-group v-model="payType">
<!--          <el-radio label="alipay" border>支付宝</el-radio>-->
          <el-radio label="usdt" border>USDT</el-radio>
        </el-radio-group>
        </div>
        <div class="mt20">
          <div><el-button  type="primary" :loading="isLoading1"  @click="go_pay">去支付</el-button></div>

        </div>
      </div>
    <el-dialog title="USDT支付" :visible.sync="oldDialog"  center width="600px">
      <div>
        <div class="bg_white radius-top-20">
          <div class="pad flex-center flex-column">
            <div class=" fs22">请支付 <span class="fs30 bold">{{money_usdt}}</span> USDT</div>
            <div class="pad bold blue">仅支持波场TRC20</div>
            <div class="mb10 gray999 fs14 ">总金额 {{money}}/汇率 ≈ {{money_usdt}}</div>
            <img src="../../assets/images/usdt_qrcode.jpg" style="width:300px;" />
            <div class="gray999 pad">钱包地址</div>
            <div class=" pad510 bg_gray_eee radius-5 fs18" @click="copy('aaa')" >
              {{plat_usdt_address}}
              <image src="../static/img/fwxy.png" class="pic-15"></image>
            </div>
            <div class="fs14 gray999 mt20">
              <div>温馨提示： 金额务必要准确  ，如有问题请联系客服 </div>

            </div>
            <div class="flex-center w100 mt20">
              <button class="but_blue w45" @click="refresh_usdt_order">已完成支付</button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 模态框 -->
    <el-dialog title="扫码支付" :visible.sync="qrDialog" center width="600px">
      <div class="cu-modal bottom-modal ">
        <div class="centered-box bg-white" style="border-radius: 12px;" @tap.stop="">
          <div class="wanl-modal" style="padding-bottom: 0px;">
            <div class="head padding-bj flex-center" style="flex-direction: column;">
              <div class="content " style="margin-bottom: 20px;"><div class="flex-center fs16">请截图保存到相册,使用扫一扫完成付款</div></div>
              <vue-qr
                  :text="qrcode"
                  :size="280"
                  :margin="20"
                  colorDark="#333"
                  backgroundColor="#fff"
                  logoScale="0.21"
                  logoMargin="25px"
              ></vue-qr>
            </div>
          </div>
          <div class="flex-center w100 mt20">
            <button class="but_blue w45" @click="wcsm">已完成支付</button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2';
  import VueQr from 'vue-qr'
    export default {
        name: "Info",
       components:{VueQr},
        data() {
            return {
              isLoading1:false,
              qrDialog:0,
              oldDialog:0,
              payType:'usdt',
              money:'',
              usd_exchange_rate:7.09,
              plat_usdt_address:'TQzGUwkvUm7MdGbSEeCERA2378UeGMfqeB',
              money_usdt:0,
              userInfo:{},
              qrcode:"https://www.baidu.com",
            }
        },
        mounted() {
            setTimeout(this.getUserInfo,200);
        },
        methods: {
          returnFloat2:function(value){
            value = Math.round(parseFloat(value) * 100) / 100;
            if (value.toString().indexOf(".") < 0) {
              value = value.toString() + ".00";
            }
            return value;
          },


          async getUserInfo() {
              const {ret,data} = await this.$api.user.getUserInfo();
              if (ret === 1000){
                  this.userInfo = data;
              }
          },

          async go_pay(){
            var $this = this


            if(this.money<=0){
              this.$message.error('请输入充值金额');
              return ;
            }
            if(this.payType=='usdt') {
              this.oldDialog = 1;
            }

            this.isLoading1=true;

            const postdata={money:this.money,pay_type:this.payType};
            const reponse=await this.$api.user.addChargeOrder(postdata);console.log(reponse);
            $this.order_id = reponse.data.order_id;
            $this.money_usdt=reponse.data.usdt;
            console.log(reponse)
            this.isLoading1=false;

            const postdata1={order_id:$this.order_id,pay_type:this.payType};


            if(this.payType=='usdt'){
              this.oldDialog=1;
              this.isLoading1=false;
              return;
            }
            this.isLoading1=true;
            // const postdata1={order_id:'77',pay_type:'wxpay'};
            const reponse2=await this.$api.user.payCharge(postdata1);
            if(reponse2.data.open_type == 0 || reponse2.data.open_type == 2){
              location.href=reponse2.data.pay_url;
              //window.open(reponse2.data.pay_url);
            }
            if(reponse2.data.open_type == 'usdt'){
              $this.qrcode=reponse2.data.pay_url;
              $this.qrDialog=1;
            }
            console.log(reponse2)
            this.isLoading1=false;

          },
          async refresh_usdt_order(){
            var postdata={order_id:this.order_id};
            const reponse=await this.$api.user.refreshChargeUsdt(postdata);
            this.success('支付成功！正在跳转..');
            setTimeout(()=>{
              this.go('/pages-user/order_list');
            },1000)


          },
          wcsm(){
            this.qrDialog=0;
            console.log('完成')
          },

        }
    }
</script>

<style scoped>
.title3{
  border-left: 5px solid #008df2;
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 500;
}
    .if-box{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .if-box .edit-profile{
        width: 100%;
        height: 100px;
        margin-bottom: 20px;
    }
    .if-box .edit-profile .profile-box{
        width: 98px;
        height: 98px;
        margin: 0 auto;
        border: 1px solid #C0C4CC;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
    }
    .if-box .edit-profile .profile-box .edit-icon{
        width: 98px;
        height: 98px;
        background-color: rgba(0,0,0,0.5);
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
        color: #ffffff;
        line-height: 98px;
        display: none;
        cursor: pointer;
    }
    .if-box .edit-profile .profile-box:hover .edit-icon{
        display: block;
    }
    .if-box .edit-profile .profile-box .edit-icon i{
        font-size: 32px;
    }
    .if-box .if-item{
        width: 100%;
        height: 60px;
        font-size: 20px;
        line-height: 60px;
        overflow: hidden;
    }
    .if-box .if-item .l{
        display: inline-block;
        width: 260px;
        height: 60px;
        color: #666666;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }
    .if-box .if-item .r{
        display: inline-block;
        width: 150px;
        height: 60px;
        margin-left: 10px;
        vertical-align: top;
    }
    .if-box .if-item .r .inp{
        width: 200px;
    }
    .ml-10{
        margin-left: 10px;
    }
</style>
